import type { RouteObject } from 'react-router';
import { SettingsPage } from './SettingsPage';

/** Every signed-in user has at least "My profile"; each section checks its own permission. */
export const routes: RouteObject[] = [{ path: '/settings/*', element: <SettingsPage /> }];
